import axios from 'axios';

// Setup api client
const apiClient = axios.create({
  baseURL: payload.services.searchservice.url,
  headers: {
    'request-region': payload.generic.requestRegion
  }
});

export default {
  async fetchProductsByUids(uids, industry, token = null, withStackInfo = false) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    let url = `/api/v1/product-comparison/productsByUids?uids=${uids.join(',')}&i=${industry}`;

    if (withStackInfo) {
      url = `${url}&type=imageStacks&stackFileVersion=2`;
    }

    const result = (await apiClient.get(url, config)).data;

    result.forEach((product) => {
      if (product[industry] && typeof product[industry] === 'object') {
        Object.keys(product[industry]).forEach((key) => {
          product[key] = product[industry][key];
        });

        delete product[industry];
      }
    });

    return result;
  },

  async getAdvancedComparisonsForProduct(uid, industries = null, token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    let url = `/api/v1/product-comparison/advanced/by-product/${uid}`;

    if (industries) {
      const industriesParam = Array.isArray(industries) ? industries.join(',') : industries;
      url += `?industries=${industriesParam}`;
    }

    return (await apiClient.get(url, config)).data;
  }
};
